import React, { createContext, useContext, useState, useCallback, useSelector } from "react";
import { isEqual, isFunction } from "lodash";
import {initialFilter} from "./PharmaReceivingUIHelpers";

const PharmaReceivingUIContext = createContext();

export function usePharmaReceivingUIContext() {
  return useContext(PharmaReceivingUIContext);
}

export const ReceivingUIConsumer = PharmaReceivingUIContext.Consumer;

export function PharmaReceivingUIProvider({ pharmaReceivingUIEvents, children }) {

  const [ordersQueryParams, setOrdersQueryParamsBase] = useState( initialFilter );
  const [defaultView, setDefaultView] = useState( "Pendientes" );
  const [selectedIds, setSelectedIds] = useState([]);
  const [orderForEdit, setOrderForEdit] = useState({});

  const setOrdersQueryParams = useCallback((nextQueryParams) => {
    
    setOrdersQueryParamsBase((prevQueryParams) => {

        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }

        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }

        return nextQueryParams;

    });
  }, []);


  const value = {
    ordersQueryParams,
    setOrdersQueryParams,
    setOrdersQueryParamsBase,
    defaultView,
    setDefaultView,
    selectedIds,
    setSelectedIds,
    orderForEdit,
    setOrderForEdit,
    openEditOrderPage: pharmaReceivingUIEvents.openEditOrderPage,
  };

  return (
    <PharmaReceivingUIContext.Provider value={value}>
      {children}
    </PharmaReceivingUIContext.Provider>
  );
}
